module.exports = __webpack_public_path__ + "static/media/globalAts.6e604c75.png";